import React from "react";
import { UiWhiteCard } from "./common/UiWhiteCard";
import { UiButton, UiIconButton } from "./common/UiButton";

export const UiNotificationCardWrapper = (props) => {
  const className = `df-db-alertbox ${
    props.className ? props.className : "df-db-alertbox"
  }`;

  return (
    <>
      <UiWhiteCard className={className}>
        <div className="df-db-alerbox__wrapper">
          <div className="df-db-alertbox__inner">
            <div className="text-right">
              <UiIconButton
                icon={props.icon}
                className="df-icon-btn"
                onClick={props?.closeBtnFunc}
              />
            </div>
            <h5>{props.title}</h5>
            {props.children}
            <div className="text-right">
              <UiButton
                onClick={props?.seeDetailsLink}
                name={props.name}
                className="df-primary-underlined-btn"
              />
            </div>
          </div>
        </div>
      </UiWhiteCard>
    </>
  );
};
